import React, {Component} from 'react';
//import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
//import Card from 'react-bootstrap/Card';
//import Nav from 'react-bootstrap/Nav';
import {
    Table,
    Text,
    keys,
    Group,
    UnstyledButton,
    rem,
    Center,
    Paper,
    Collapse,
    Loader
} from '@mantine/core';

import dayjs from 'dayjs';

import classes from '../TableSort.module.css';
import { IconSelector, IconChevronDown, IconChevronUp } from '@tabler/icons-react';

import HardwareTicketDataService from '../../services/hardware-ticket-activities';

import {REPORT_TENANT_CHANGE_RESOLVED_WARNING_TICKETS} from '../../features/actions/Is-Logged-Actions';
import { 
    REPORT_TIIMESPAN_CHANGE_RESOLVED, 
    REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, 
    REPORT_ASSIGNED_TO_CHANGE_RESOLVED, 
    UPDATE_HOT_TICKET_REPORT_OPEN_STATUS,
    UPDATE_HOT_SORTING
} from '../../features/actions/Reports-Actions';


// const chartData = {
//     labels: ['January', 'February', 'March',
//              'April', 'May'],
//     datasets: [
//       {
//         label: 'Rainfall',
//         backgroundColor: [
//           '#B21F00',
//           '#C9DE00',
//           '#2FDE00',
//           '#00A6B4',
//           '#6800B4'
//         ],
//         hoverBackgroundColor: [
//         '#501800',
//         '#4B5000',
//         '#175000',
//         '#003350',
//         '#35014F'
//         ],
//         data: [65, 59, 80, 81, 56]
//       }
//     ]
//   }

//import { LOGOUT } from '../features/actions/Is-Logged-Actions';

function filterData(data, search) {
    const query = search.toLowerCase().trim();
    return data.filter((item) =>
        keys(data[0]).some((key) => item[key].toLowerCase().includes(query))
    );
}

function sortData(
    data,
    payload
) {
    const { sortBy } = payload;

    if (!sortBy) {
        return filterData(data, payload.search);
    }

    return filterData(
        [...data].sort((a, b) => {
            if (payload.reversed) {
                return b[sortBy].localeCompare(a[sortBy]);
            }

            return a[sortBy].localeCompare(b[sortBy]);
        }),
        payload.search
    );
}

function Th(props) {
    const Icon = props.sorted ? (props.reversed ? IconChevronUp : IconChevronDown) : IconSelector;
    return (
        <Table.Th className={classes.th}>
            <UnstyledButton onClick={props.onSort} className={classes.timespanReportControl}>
                <Group justify="left"/* justify="space-between" */>
                    <Text fw={800} fz="sm">
                        {props.children}
                    </Text>
                    <Center className={classes.icon}>
                        <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </Center>
                </Group>
            </UnstyledButton>
        </Table.Th>
    );
}

class WarningTickets extends Component {


    constructor(props) {
        super(props); 

        this.getWarningTickets = this.getWarningTickets.bind(this);
        this.goToHardwareTicketDetails = this.goToHardwareTicketDetails.bind(this);
        this.goToHoldingTicketDetails = this.goToHoldingTicketDetails.bind(this);
 
        this.state = {
            warningTickets: [],
            itemCount: 0,
            showLoader: false,
            sortBy: "id",
            sortOrder: "ASC"
        };

    }

    setSorting(field) {
        const reversed = field === this.state.sortBy ? !this.state.reverseSortDirection : false;
        const search = this.state.search;
        this.setState({
            reverseSortDirection: reversed,
            sortBy: field,
            sortedData: sortData(this.state.data, { sortBy: field, reversed, search })
        });
    };

    componentDidMount() {
        this.setState({
            sortBy: this.props.reportInfo.hot_sort_by,
            sortOrder: this.props.reportInfo.hot_sort_order
        }, () => this.getWarningTickets())
        
    }


    componentDidUpdate(prevProps) {
        if(this.props.loggedStatus.report_tenant_change_detected_warning_tickets && !prevProps.loggedStatus.report_tenant_change_detected) {
            this.props.REPORT_TENANT_CHANGE_RESOLVED_WARNING_TICKETS();

            // get the new list of overdue tickets
            this.getWarningTickets();
        }

        if(this.props.reportInfo.report_timespan_change_detected || this.props.reportInfo.report_timespan_type_change_detected || this.props.reportInfo.report_assigned_to_change_detected) {
            if(this.props.reportInfo.report_timespan_change_detected && !prevProps.reportInfo.report_timespan_change_detected) {
                this.props.REPORT_TIIMESPAN_CHANGE_RESOLVED();
                console.log("timespan change detected in child 3");

                this.getWarningTickets();
            }

            else if(this.props.reportInfo.report_timespan_type_change_detected && !prevProps.reportInfo.report_timespan_type_change_detected) {
                this.props.REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED();
                console.log("timespan type change detected in child 3");

                this.getWarningTickets();
            }

            else if(this.props.reportInfo.report_assigned_to_change_detected && !prevProps.reportInfo.report_assigned_to_change_detected) {
                this.props.REPORT_ASSIGNED_TO_CHANGE_RESOLVED();
                console.log("timespan assigned to change detected in child 3");

                this.getWarningTickets();
            }
        }
    }

    
    // use the global state value for the selected tenant from the report component to get the necessary warning ticket info
    getWarningTickets() {
        this.setState({
            showLoader: true
        });

        if(this.props.reportInfo.timespan && this.props.reportInfo.timespanAssignedToArray && this.props.reportInfo.timespan.length > 1) {
            var timespan = [this.props.reportInfo.timespan[0] ? dayjs(Date.parse(this.props.reportInfo.timespan[0])).$d : null, this.props.reportInfo.timespan[1] ? dayjs(Date.parse(this.props.reportInfo.timespan[1])).$d : null]

            console.log("Timespan in getWarningTickets: ", timespan);
            // generate the list of id numbers user has requested in the filter drop down
            let requesterIdList = [];

            for(let r = 0; r < this.props.reportInfo.timespanAssignedToArray.length; r++) {
                requesterIdList.push(this.props.reportInfo.timespanAssignedToArray[r].value);
            }

            console.log("List of ids to send: ", requesterIdList);


            HardwareTicketDataService.getWarningTickets(this.props.loggedStatus.report_tenant_id_selected, timespan, this.props.reportInfo.timespanType, requesterIdList, this.props.loggedStatus.id, this.props.loggedStatus.timezone_adjustment_factor)
            .then(response => {
                console.log("Warning ticket list returned: ", response);
                this.setState({
                    warningTickets: response.data.results,
                    itemCount: response.data.rowCount,
                    showLoader: false
                }, () => this.sortTable(this.state.warningTickets, this.state.sortBy, this.state.sortOrder));
            })
            .catch(e => {
                console.log(e);
            });
        }
    }

    goToHardwareTicketDetails(id) {
        this.props.history.push(`/hardwareTickets/${id}`);
    }

    goToHoldingTicketDetails(id) {
        this.props.history.push(`/clarifyTicket/${id}`);
    }

    handleReportOpenChange() {
        this.props.UPDATE_HOT_TICKET_REPORT_OPEN_STATUS();     // toggles global state value between true and false
    }

    // locally sorts the data displayed in the table based on the column clicked and sort order
    // affects warningTickets []
    sortTable(array, sortBy, sortOrder) {

        const getAwaitingValue = (ticket) => {
            const { source, time_of_response } = ticket;
            if (source === "Hardware") {
              return time_of_response == null ? "Response" : "Resolution";
            } else {
              return time_of_response == null ? "Response" : "Clarification";
            }
        };

        const sortedArray = [...array].sort((a, b) => {
            let aVal;
            let bVal;
        
            // Treat null or undefined assigned_tech_name as "Unassigned"
            if (sortBy === "assigned_tech_name") {
                aVal = a.assigned_tech_name ?? "Unassigned";
                bVal = b.assigned_tech_name ?? "Unassigned";
            }

            else if (sortBy === "awaiting") {
                aVal = getAwaitingValue(a);
                bVal = getAwaitingValue(b);
            }

            else {
                aVal = a[sortBy] ?? '';
                bVal = b[sortBy] ?? '';
            }
        
            // For string comparison (case-insensitive)
            if (typeof aVal === "string" && typeof bVal === "string") {
              const result = aVal.toLowerCase().localeCompare(bVal.toLowerCase());
              return sortOrder === "ASC" ? result : -result;
            }
        
            // For number or date comparison
            if (aVal > bVal) return sortOrder === "ASC" ? 1 : -1;
            if (aVal < bVal) return sortOrder === "ASC" ? -1 : 1;
            return 0;
        });

        console.log("here is the sorted array: ", sortedArray);
        
        //return sortedArray;
        this.setState({
            warningTickets: sortedArray
        });
    }

    // fired when user clicks a table header - sorts timespan tickets by column and flips sort order
    handleSortByAndOrderChange(new_column_name) {

        let newSortOrder;
        if(this.state.sortOrder === "ASC") {
            newSortOrder = "DESC";
        }

        else {
            newSortOrder = "ASC";
        }

        // if this is a new column, change both the column sorted and the order
        if(new_column_name !== this.state.sortBy) {
            this.setState({
                sortBy: new_column_name,
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.warningTickets, new_column_name, newSortOrder));
        }

        // otherwise it was the same column, so just change the sort order
        else {
            this.setState({
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.warningTickets, this.state.sortBy, newSortOrder));
        }

        // update global state for sortBy and sortOrder here
        this.props.UPDATE_HOT_SORTING({sortBy: new_column_name});
    }


    render() {
        const rows = this.state.warningTickets.map((ticket) => {
            if (ticket.source === "Hardware") {
                return <Table.Tr key={`hardware_${ticket.id}`} onClick={(event) => {event.stopPropagation(); this.goToHardwareTicketDetails(ticket.id)}}>
                    <Table.Td w="14%">{`# ${ticket.id}`}</Table.Td>
                    <Table.Td w="14%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
                    <Table.Td w="16%">{ticket.asker_name}</Table.Td>
                    <Table.Td w="16%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
                    <Table.Td w="10%">{ticket.time_of_response === null ? "Response" : "Resolution"}</Table.Td>
                    <Table.Td w="15%">{ticket.formatted_date_time_created}</Table.Td>
                    <Table.Td w="15%">{ticket.late_text ? ticket.late_text : "TBD"}</Table.Td>
                </Table.Tr>
            }

            else {
                return <Table.Tr key={`unclarified_${ticket.id}`} onClick={(event) => {event.stopPropagation(); this.goToHoldingTicketDetails(ticket.id)}}>
                    <Table.Td w="14%">{`Temp# ${ticket.id}`}</Table.Td>
                    <Table.Td w="14%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
                    <Table.Td w="16%">{ticket.asker_name}</Table.Td>
                    <Table.Td w="16%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
                    <Table.Td w="10%">{ticket.time_of_response === null ? "Response" : "Clarification"}</Table.Td>
                    <Table.Td w="15%">{ticket.formatted_date_time_created}</Table.Td>
                    <Table.Td w="15%">{ticket.late_text ? ticket.late_text : "TBD"}</Table.Td>
                </Table.Tr>
            }
        })


        return (
            <>
                <Paper withBorder p="md" radius="md" display="block" m="5px" onClick={() => this.handleReportOpenChange()}>
                    {this.state.showLoader === true ? 
                        <div><Text size="xl" fw={700} component="span">{`Almost Due Tickets ( `}</Text><span style={{ display: 'inline-flex', alignItems: 'center' }}><Loader type="dots" color="orange"/></span><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.hot_ticket_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                        :
                        <div><Text size="xl" fw={700} component="span">{`Almost Due Tickets ( `}</Text><Text size="xl" fw={700} component="span" c="orange">{`${this.state.itemCount}`}</Text><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.hot_ticket_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                    }
                    <Collapse in={this.props.reportInfo.hot_ticket_report_open}>
                        <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
                            <Table.Thead>
                                <Table.Tr>
                                    <Th 
                                        w="14%"
                                        sorted={this.state.sortBy === 'id'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("id")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "id" ? "activeMyAssignedTicketsHeader" : ""}>ID</div>
                                    </Th>
                                    <Th 
                                        w="14%"
                                        sorted={this.state.sortBy === 'sla_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("sla_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "sla_name" ? "activeMyAssignedTicketsHeader" : ""}>Priority</div>
                                    </Th>
                                    <Th 
                                        w="16%"
                                        sorted={this.state.sortBy === 'asker_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("asker_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "asker_name" ? "activeMyAssignedTicketsHeader" : ""}>Requester</div>
                                    </Th>
                                    <Th 
                                        w="16%"
                                        sorted={this.state.sortBy === 'assigned_tech_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("assigned_tech_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "assigned_tech_name" ? "activeMyAssignedTicketsHeader" : ""}>Assigned To</div>
                                    </Th>
                                    <Th 
                                        w="10%"
                                        sorted={this.state.sortBy === 'awaiting'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("awaiting")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "awaiting" ? "activeMyAssignedTicketsHeader" : ""}>Awaiting</div>
                                    </Th>
                                    <Th 
                                        w="15%"
                                        sorted={this.state.sortBy === 'formatted_date_time_created'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("formatted_date_time_created")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "formatted_date_time_created" ? "activeMyAssignedTicketsHeader" : ""}>Time Created</div>
                                    </Th>
                                    <Th 
                                        w="15%"
                                        sorted={this.state.sortBy === 'minutes_since_sent'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("minutes_since_sent")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "minutes_since_sent" ? "activeMyAssignedTicketsHeader" : ""}>Overdue By</div>
                                    </Th>
                                </Table.Tr>
                            </Table.Thead>
                        {/* </Table> */}
                        {/* <Table highlightOnHover="true" style={{ cursor: "pointer" }}> */}
                        {this.props.reportInfo.hot_ticket_report_open ? 
                            <Table.Tbody>
                                {rows && rows.length > 0 ? (
                                    rows
                                ) : (
                                    <Table.Tr>
                                        <Table.Td colSpan={7}>
                                            <Text fw={500} ta="center">
                                                Nothing found
                                            </Text>
                                        </Table.Td>
                                    </Table.Tr>
                                )}
                            </Table.Tbody>
                            :
                            undefined
                        }
                        </Table>
                    </Collapse>
                </Paper>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,    // Use global state to control which link is highlighted
        reportInfo: state.reports
    };
}

export default connect(mapStateToProps, { REPORT_TENANT_CHANGE_RESOLVED_WARNING_TICKETS, REPORT_TIIMESPAN_CHANGE_RESOLVED, REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, REPORT_ASSIGNED_TO_CHANGE_RESOLVED, UPDATE_HOT_TICKET_REPORT_OPEN_STATUS, UPDATE_HOT_SORTING })(WarningTickets);